import './App.css';
// import '../public/lib/owlcarousel/owl.carousel.js';

import Navbar from './components/navbar';
import Footer from './components/footer';
import Header from './components/header';
import Home from './components/home';
import Contactus from './components/Contactus';
import Services from './components/Services';
import Aboutus from './components/Aboutus';
import Testimonial from './components/Testimonial';
import Gallery from './components/Gallery';

import { BrowserRouter as Router, Route, Routes  } from 'react-router-dom';
function App() {
  return (
    <Router>
    <>
      <Header />
      <Navbar />
      <Routes>
        
        <Route exact path="/"  element={<Home />} />
        <Route exact path="/Services" element={<Services />} />
        <Route path="/Aboutus" element={<Aboutus />} />
     
        <Route path="/Testimonial" element={<Testimonial />} />
        <Route path="/Gallery" element={<Gallery />} />
        
        <Route path="/Contactus" element={<Contactus />} />
      </Routes>
      
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i
            className="bi bi-arrow-up"></i></a>
        
 

      <a
  href="https://wa.me/260978770051"
  className="whatsapp-float anim-blink"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-whatsapp"></i>
</a>
      
      <Footer />
    </>
  </Router>

  


  );
}

export default App;
